import { render, staticRenderFns } from "./Performancedeclaration.vue?vue&type=template&id=a1ca0a46&scoped=true"
import script from "./Performancedeclaration.vue?vue&type=script&lang=js"
export * from "./Performancedeclaration.vue?vue&type=script&lang=js"
import style0 from "./Performancedeclaration.vue?vue&type=style&index=0&id=a1ca0a46&prod&lang=less&scoped=true"
import style1 from "./Performancedeclaration.vue?vue&type=style&index=1&id=a1ca0a46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ca0a46",
  null
  
)

export default component.exports